import { patchWithRedirect } from 'utils/axios'

const BASE_URL =
  process.env.NODE_ENV === 'development'
    ? 'http://localhost:3990/'
    : process.env.REACT_APP_HOMEPAL_MDM_API_PROD

const URL = `${BASE_URL}v1/report-blocks`

export async function reorderBlockWidgets(
  blockId: string,
  body: Array<{ id: string; index: number }>
) {
  return patchWithRedirect(`${URL}/${blockId}/widgets/reorder`, { data: body })
}
